
import { Component, Prop, Vue } from 'vue-property-decorator'
import { Order } from '@/models/index'

@Component({
  name: 'OrderSummary'
})
export default class extends Vue {
  @Prop({ required: true }) private order!: Order
}
